import React from 'react';
import { Clearfix } from 'react-bootstrap';
import { injectIntl } from 'react-intl';

import FormAutocomplete from 'components/forms/FormAutocomplete';

class CmsNewGrid extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      gridGroup: 'standard',
    };
  }

  onChange = (e, gridGroup) => {
    e.stopPropagation();
    e.preventDefault();

    this.setState({ gridGroup });
  };

  addGrid = (e, data) => {
    e.stopPropagation();
    e.preventDefault();

    const { addGrid } = this.props;
    addGrid(data);
    document.body.click();
  };

  addDynamicElement = data => {
    const { addDynamicElement } = this.props;
    addDynamicElement(data);
    document.body.click();
  };

  render() {
    const {
      intl: { messages },
    } = this.props;
    const { gridGroup } = this.state;

    return (
      <div class="ms-grid-selection">
        <Clearfix class="m-b-10 bg-master-lightest font-secondary all-caps fs-11">
          <a href="#standard" onClick={e => this.onChange(e, 'standard')} class="block pull-left padding-10">
            {messages.cms_standard}
          </a>
          <a href="#dynamic" onClick={e => this.onChange(e, 'dynamic')} class="block pull-left padding-10">
            {messages.cms_elements}
          </a>
        </Clearfix>

        {gridGroup === 'standard' && (
          <ul>
            <li
              class="ms-grid-option-fluid"
              onClick={e => {
                this.addGrid(e, [
                  { name: 'isFluid', value: 'yes' },
                  { name: 'paddingTop', value: 50 },
                  { name: 'paddingBottom', value: 50 },
                ]);
              }}
            >
              <div class="ms-grid-mock">
                <div class="ms-row-mock">{messages.grid_fluid}</div>
              </div>
            </li>
            <li
              class="ms-grid-option-normal"
              onClick={e => {
                this.addGrid(e, [
                  { name: 'isFluid', value: 'no' },
                  { name: 'paddingTop', value: 50 },
                  { name: 'paddingBottom', value: 50 },
                ]);
              }}
            >
              <div class="ms-grid-mock">
                <div class="ms-row-mock">{messages.grid_normal}</div>
              </div>
            </li>
          </ul>
        )}

        {gridGroup === 'dynamic' && (
          <FormAutocomplete
            label={messages.select_element}
            name="dynamicElement"
            autocompleteType="dynamicElement"
            returnValueObject
            onChange={(name, dynamicElement) => this.addDynamicElement(dynamicElement)}
          />
        )}
      </div>
    );
  }
}

export default injectIntl(CmsNewGrid);
